import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import { LOCATIONS } from '../../lib/locations';
import type { Vote } from '../../lib/types';
export function ResultsCharts({
  votes
}: {
  votes: Vote[];
}) {
  const data = LOCATIONS.map(loc => ({
    name: loc.city,
    votes: votes.filter(v => v.city === loc.city).length,
    fill: loc.chartColor
  }));
  const hasVotes = votes.length > 0;
  return <div className="grid gap-4 lg:grid-cols-2" data-id="element-40" data-mp="3jxrqlp1wze04">
      <ChartCard title="Live Results" subtitle="Votes by destination" data-id="element-41" data-mp="3jykr48aa579t">
        {hasVotes ? <ResponsiveContainer width="100%" height={280} data-id="element-42" data-mp="363ibgtfms3jt">
            <BarChart data={data} margin={{
          top: 8,
          right: 8,
          left: -18,
          bottom: 0
        }} data-id="element-43" data-mp="3b57oufqbstb2">
              <CartesianGrid strokeDasharray="3 3" stroke="#eef2ff" vertical={false} data-id="element-44" data-mp="2w6vuifqfdwn2" />
              <XAxis dataKey="name" tick={{
            fontSize: 12,
            fill: '#64748b'
          }} axisLine={false} tickLine={false} data-id="element-45" data-mp="316rve63tt7ye" />
              <YAxis allowDecimals={false} tick={{
            fontSize: 12,
            fill: '#64748b'
          }} axisLine={false} tickLine={false} data-id="element-46" data-mp="1p6a7tqiellgi" />
              <Tooltip cursor={{
            fill: '#f5f3ff'
          }} contentStyle={{
            borderRadius: 16,
            border: 'none',
            boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
          }} data-id="element-47" data-mp="1z4hglm2jgx7f" />
              <Bar dataKey="votes" radius={[10, 10, 0, 0]} maxBarSize={54} data-id="element-48" data-mp="16fsmw83tbu5p">
                {data.map(d => <Cell key={d.name} fill={d.fill} data-id="element-49" data-mp="1k7gsrtngxme8" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer> : <Empty data-id="element-50" data-mp="1fe49lz1k67sv" />}
      </ChartCard>

      <ChartCard title="Vote Share" subtitle="Distribution across cities" data-id="element-51" data-mp="rpuq53rthw4w">
        {hasVotes ? <ResponsiveContainer width="100%" height={280} data-id="element-52" data-mp="npuchlcjloyw">
            <PieChart data-id="element-53" data-mp="nn85pnxh7dhq">
              <Pie data={data.filter(d => d.votes > 0)} dataKey="votes" nameKey="name" innerRadius={55} outerRadius={95} paddingAngle={3} data-id="element-54" data-mp="2mucbq7dbguoe">
                {data.filter(d => d.votes > 0).map(d => <Cell key={d.name} fill={d.fill} data-id="element-55" data-mp="31hxgs6tr53yy" />)}
              </Pie>
              <Tooltip contentStyle={{
            borderRadius: 16,
            border: 'none',
            boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
          }} data-id="element-56" data-mp="23wrlavuwlo1o" />
              <Legend iconType="circle" wrapperStyle={{
            fontSize: 12,
            color: '#64748b'
          }} data-id="element-57" data-mp="2dsl7z82c6xx6" />
            </PieChart>
          </ResponsiveContainer> : <Empty data-id="element-58" data-mp="3p8t4arr6dd0e" />}
      </ChartCard>
    </div>;
}
function ChartCard({
  title,
  subtitle,
  children
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}) {
  return <section className="rounded-3xl bg-white p-5 shadow-soft" data-id="element-59" data-mp="1ikj0pctnehav">
      <h2 className="font-display text-lg font-700 text-slate-800" data-id="element-60" data-mp="1ilu255zmfcyt">{title}</h2>
      <p className="mb-3 text-sm text-slate-500" data-id="element-61" data-mp="1dlptu38v9ojo">{subtitle}</p>
      {children}
    </section>;
}
function Empty() {
  return <div className="flex h-[280px] items-center justify-center rounded-2xl bg-slate-50 text-slate-400" data-id="element-62" data-mp="13v4lho3e55nk">
      No votes yet — results will appear here.
    </div>;
}